// extracted by mini-css-extract-plugin
export default {"container":"AdminHome_container__GnL-q","adminNotificationLink":"AdminHome_adminNotificationLink__Ks5Ze"};